<template>
    <div class="main-data-digitaltoolsconfig">
        <div class="opera-btn">
            <el-button type="primary" @click="saveDigitalToolsConfig">保存</el-button>
            <el-button  @click="cancelDigitalToolsConfig">取消</el-button>
        </div>
        <div class="main-data-digitaltoolsconfig-content">
            <div class="content-box">
                <el-transfer v-model="value" :data="data" :titles="['数字化工具列表', '已选数据']"></el-transfer>
            </div>
        </div>
    </div>
</template>

<script>
import {} from '@/data-model';
export default{
    components: {

    },
    props: {
        dataList: {
            type: Array
        }
    },
    computed: {
    },
    data () {
        return {
            value: [],
            data: [
                {
                    'key': '1',
                    'label': '我的流程'
                },
                {
                    'key': '2',
                    'label': '我的任务'
                },
                {
                    'key': '3',
                    'label': '流程效率分析'
                },
                {
                    'key': '4',
                    'label': '任务效率分析'
                },
                {
                    'key': '5',
                    'label': '流程任务效率统计'
                }
            ]
        };
    },
    created () {
        if (this.dataList) {
            this.value = [];
            for (let i = 0; i < this.dataList.length; i++) {
                this.value.push(this.dataList[i].key);
            }
        }
    },
    methods: {
        cancelDigitalToolsConfig () {
            this.$emit('closeDigitalToolsConfig');
        },
        saveDigitalToolsConfig () {
            let obj = [];
            for (let i = 0; i < this.value.length; i++) {
                let cur = this.value[i];
                let o = this.data.find(item => item.key === cur);
                obj.push(o);
            }
            this.$emit('configDigitalToolsConfig', obj);
        }
    }
};
</script>

<style lang="less">
    .showDigitalToolsConfig{
        .el-dialog__header{
            display: none;
        }
        .el-dialog__body{
            padding-top: 0px;
            width: 98%;
            height: 90%;
            .main-data-digitaltoolsconfig{
                width: 100%;
                height: 100%;
                text-align: center;
                .opera-btn{
                    height: 40px;
                    line-height: 40px;
                    text-align: right;
                    margin-bottom: 10px;
                    margin-top: 10px;
                }
            }
            .main-data-digitaltoolsconfig-content{
                width: 100%;
                height: 100%;
                .content-box{
                    text-align: left;
                    height: 80%;
                    width: 50%;
                    margin-left: 35%;
                    .el-transfer{
                        height: 90%;
                        .el-transfer-panel{
                            height: 600px;
                            .el-transfer-panel__body{
                                height: 600px;
                                .el-checkbox-group{
                                   height: 600px;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/DataWarehousing/DigitalToolsConfig.vue